module.exports = __webpack_public_path__ + "static/airbus-504d37742ce6f037da5724f193f17d1f.jpg";